import { useState } from "react";
import { useTranslation } from "react-i18next";

const CampaignListRowActions = ({ onEdit, onDuplicate, onDelete }) => {
  const { t } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);

  const closeMenu = () => setIsOpen(false);

  return (
    <article className="table-standard-row-cell table-standard-row-actions">
      <div className="table-standard-row-actions-menu-anchor">
        <button
          type="button"
          className="table-standard-row-actions-dots"
          onClick={(event) => {
            event.stopPropagation();
            setIsOpen((open) => !open);
          }}
          aria-label={t("Actions")}
          aria-expanded={isOpen}
        >
          <i className={`fas ${!isOpen ? "fa-ellipsis-v" : "fa-times"}`} />
        </button>
        <div className={`action-choice ${isOpen ? "display-action" : ""}`}>
          <button
            type="button"
            className="action"
            onClick={(event) => {
              event.stopPropagation();
              onEdit();
              closeMenu();
            }}
          >
            {t("Edit")}
          </button>
          <button
            type="button"
            className="action"
            onClick={(event) => {
              event.stopPropagation();
              onDuplicate();
              closeMenu();
            }}
          >
            {t("campaign.duplicate")}
          </button>
          <button
            type="button"
            className="action"
            onClick={(event) => {
              event.stopPropagation();
              onDelete();
              closeMenu();
            }}
          >
            {t("Delete")}
          </button>
        </div>
      </div>
    </article>
  );
};

export default CampaignListRowActions;
